<!--
무자료 등록(재고방식) > stepper > 1개스텝
------------------------------------
-->
<template>
    <div class="step" :class="className">
        <div class="title">{{ title }}</div>
        <div class="desc" v-show="this.step === this.currentStep">
            <slot name="desc" ></slot>
        </div>
        <slot name="add-info" ></slot>

    </div>
</template>

<script>
    export default {
        components: {
//            'stepper': require('./stepper.vue').default,
        },
        props: {
            /**
             * 단계
             */
            step: {
                type: Number,
            },

            /**
             * 현재 진행단계
             */
            currentStep: {
                type: Number,
            },

            /**
             * title
             */
            title: {
                type: String,
            },

        },
        data: function () {
            return {
            };
        },
        computed: {
            className() {
                return {
                    'step-done': this.step < this.currentStep,
                    'step-active': this.step === this.currentStep,
                };
            },
        },
        methods: {

        },


    }
</script>

<style lang="scss" scoped>
    /* Steps */
    .step {
        padding: 10px;
        background-color: #fff;
        color: #333;

        &:not(:first-child) {
            border-top: 1px solid #666;
        }

        /* Stepper Titles */
        .title {
            font-size: 1.25rem;
        }
        .desc {
            margin-top: 1rem;
            font-size: 1rem;
            //display: none;
        }

        &.step-done {
            background-color: #fff;
            color: #999;
            .title {
                text-decoration-line: line-through;
            }
        }
        &.step-active {
            height: 100%;
            background-color: #fdffe3;
            color: #000;

            .title {
                font-size: 1.25rem;
                font-weight: bold;
            }
        }
    }



</style>